var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetWidget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3577 12.0443C10.148 13.0926 8.60035 13.6686 6.99967 13.6663C3.31767 13.6663 0.333008 10.6817 0.333008 6.99967C0.333008 3.31767 3.31767 0.333008 6.99967 0.333008C10.6817 0.333008 13.6663 3.31767 13.6663 6.99967C13.6663 8.42367 13.2197 9.74367 12.4597 10.8263L10.333 6.99967H12.333C12.3329 5.77048 11.9082 4.57905 11.1308 3.62693C10.3534 2.67482 9.27091 2.02047 8.06656 1.77458C6.86221 1.52869 5.6099 1.70635 4.52146 2.27752C3.43302 2.84868 2.57529 3.77828 2.09336 4.90906C1.61142 6.03984 1.53488 7.30238 1.87667 8.4831C2.21846 9.66382 2.9576 10.6902 3.96906 11.3887C4.98052 12.0872 6.2022 12.4149 7.42744 12.3163C8.65267 12.2177 9.80624 11.6989 10.693 10.8477L11.3577 12.0443Z",
    fill: "#6B6B6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetWidget);
export default __webpack_public_path__ + "static/media/resetWidget.4d7e437b081d69badece890f07b40797.svg";
export { ForwardRef as ReactComponent };